import React, { useState } from 'react';
import { Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaStar, FaCartPlus, FaShoppingCart, FaEye } from 'react-icons/fa';
import { AiFillHeart } from "react-icons/ai";
import Star from "../../common/Star/Star";
import useCountDown from "../../Hooks/Couter/useCountDown";
import useCountdownByDuration from "../../Hooks/Couter/useCountdownByDuration";

const ProductCard = ({ product, handleDelete, handleAddToCart }) => {
  const countdown = useCountDown({ hours: 2, minutes: 10 });
  const timeLeft = useCountdownByDuration(
    {
      hours: product.countdownHours ?? 0,
      minutes: product.countdownMinutes ?? 0,
    },
    `countdown_${product._id}` // Unique storage key per product
  );

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);

  const handleCartClick = async () => {
    setIsAdding(true);
    if (process.env.NODE_ENV === "development") {
      console.log("Product Cart", product);
    }
    await handleAddToCart(product);
    setIsAdding(false);
    setAddedToCart(true);
  };

  const handleGoToCart = () => {
    navigate('/cart');
  };

  const handleDeleteClick = async () => {
    setIsDeleting(true);
    await handleDelete(product._id);
    setIsDeleting(false);
  };


  return (
    <>
      <div className="custom-card">
        {timeLeft !== "Time's up!" ? <span className="custom-card__countdown"><i className="d-none">DEAL</i>{timeLeft}</span> : null}
        <span className="custom-card__tag d-none">Sale</span>
        <div className="custom-card__action">
          <ul>
            <li>
              <Link to={`/product/slug/${product.slug}`} target="_blank">
                <FaEye size={20} />
              </Link>
            </li>
            <li>
              <FaShoppingCart size={20} onClick={handleCartClick} />
            </li>
            <li>
              <FaStar size={20} />
            </li>
            <li>
              <AiFillHeart size={20} />
            </li>
          </ul>
        </div>
        <div
          className="custom-card__image"
        // onClick={() => {
        //   navigate(`/product/slug/${product.slug}`);
        //   window.scrollTo({ top: 0, behavior: "smooth" });
        // }}
        // style={{ cursor: "pointer" }}
        >
          <Link to={`/product/slug/${product.slug}`} target="_blank">
            <img
              src={`${apiUrl}${product?.images[0]}` || '/images/placeholder-image.jpg'}
              alt={product.name}
            />
          </Link>
        </div>
        <div className="custom-card__content">
          <h1>{product.name}</h1>
          {/* <h1>{product._id}</h1> */}
          <p>
            <span className="custom-card__content__price">₹{product.price}</span>
            <span className="custom-line-through">₹{product?.mrpPrice}</span>
            <span className="custom-card-discount">({product?.discountPercent}% OFF)</span>
          </p>
          <p className="custom-card-stock">
            <span>In Stock:({product?.stock})</span>
          </p>
          <Star value={product?.averageRating} alignLeft="center" />
          <p className="d-flex justify-content-center align-items-center">
            <span>
              {product?.averageRating.toFixed(1)} <FaStar size={15} color="#ffc107" /> | {product.ratings.length}
            </span>
          </p>
          {/* <p className="d-flex justify-content-center align-items-center">
            <span>
              {product?.averageRating && product?.ratings?.length > 0 && (
                <>
                  <Star value={product?.averageRating} alignLeft="center" />
                  <p className="d-flex justify-content-center align-items-center">
                    <span>
                      {product?.averageRating.toFixed(1)} <FaStar size={15} color="#ffc107" /> | {product.ratings.length}
                    </span>
                  </p>
                </>
              )}
            </span>
          </p> */}
          <p className="fw-bold">FREE delivery</p>
        </div>
        <div className="custom-card__footer">
          {!addedToCart ? (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleCartClick}
              disabled={isAdding}
            >
              <FaCartPlus size={20} /> {isAdding ? "Adding..." : "Add to Cart"}
            </Button>
          ) : (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleGoToCart}
              disabled={isAdding}
            >
              <FaShoppingCart size={20} /> {isAdding ? "Wait..." : "Go to Cart"}
            </Button>
          )}
        </div>
      </div >
    </>
  );
};

export default ProductCard;

